import React from "react"

export function MyPage() {
    return (<div className="row g-5">
        <div className="col-lg-4">
            <div className="card card-custom card-stretch shadow mb-5">
                <div className="card-header">
                    <h3 className="card-title">Height 100%</h3>
                </div>
                <div className="card-body">
                    Lorem Ipsum is simply dummy text
                </div>
                <div className="card-footer">
                    Footer
                </div>
            </div>
        </div>

        <div className="col-lg-4">
            <div className="card card-custom card-stretch-50 shadow mb-5">
                <div className="card-header">
                    <h3 className="card-title">Height 100%</h3>
                </div>
                <div className="card-body">
                    Lorem Ipsum is simply dummy text
                </div>
                <div className="card-footer">
                    Footer
                </div>
            </div>

            <div className="card card-custom card-stretch-50 shadow mb-5">
                <div className="card-header">
                    <h3 className="card-title">Height 100%</h3>
                </div>
                <div className="card-body">
                    Lorem Ipsum is simply dummy text
                </div>
                <div className="card-footer">
                    Footer
                </div>
            </div>
        </div>

        <div className="col-lg-4">
            <div className="card card-custom card-stretch-33 shadow mb-5">
                <div className="card-header">
                    <h3 className="card-title">Height 33.333%</h3>
                </div>
                <div className="card-body">
                    Lorem Ipsum is simply dummy text
                </div>
                <div className="card-footer">
                    Footer
                </div>
            </div>

            <div className="card card-custom card-stretch-33 shadow mb-5">
                <div className="card-header">
                    <h3 className="card-title">Height 33.333%</h3>
                </div>
                <div className="card-body">
                    Lorem Ipsum is simply dummy text
                </div>
                <div className="card-footer">
                    Footer
                </div>
            </div>

            <div className="card card-custom card-stretch-33 shadow mb-5">
                <div className="card-header">
                    <h3 className="card-title">Height 33.333%</h3>
                </div>
                <div className="card-body">
                    Lorem Ipsum is simply dummy text
                </div>
                <div className="card-footer">
                    Footer
                </div>
            </div>
        </div>
    </div>)
}